var _rect, _rect2, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.303,
    y: 0.203,
    width: 45.721,
    height: 45.721,
    rx: 10.642,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.623,
    y: 5.525,
    width: 35.075,
    height: 35.075,
    rx: 13.3,
    fill: "current"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--gradient-start)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--gradient-stop)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.363 13.496c5.193 0 9.705 3.037 11.944 5.924 1.06 1.367 1.608 2.727 1.608 3.756 0 1.028-.548 2.388-1.608 3.756-2.239 2.886-6.75 5.923-11.944 5.923-5.193 0-9.705-3.037-11.943-5.923-1.06-1.368-1.608-2.728-1.608-3.756 0-1.029.548-2.389 1.608-3.756 2.238-2.887 6.75-5.924 11.943-5.924zm0 4.356a5.326 5.326 0 0 0-5.324 5.324 5.326 5.326 0 0 0 5.324 5.324 5.326 5.326 0 0 0 5.324-5.324 5.326 5.326 0 0 0-5.324-5.324zm0 1.936a3.39 3.39 0 0 1 3.388 3.388 3.39 3.39 0 0 1-3.388 3.388 3.39 3.39 0 0 1-3.388-3.388 3.39 3.39 0 0 1 3.388-3.388z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b56fb19383451a4ffb566b55e49a8383.svg";
export { ForwardRef as ReactComponent };